<template>
    <b-card no-body>
      <b-card-header class="border-0">
        <b-row >
          <b-col cols="6">
            <h3 class="mb-0">PDF Download Report Log</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between">
        <el-select
          class="select-primary pagination-select p-2"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
  
        <div class="p-2">
          <base-input v-model="searchQuery"
            v-on:input="debouncedHandler"
                      prepend-icon="fas fa-search"
                      placeholder="Search...(case-sensitive)">
          </base-input>
        </div>
      </b-col>
      <el-table class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="queriedData"
                @sort-change="sortChange"
                @selection-change="selectionChange"
                row-key="id">
        <el-table-column label="id"
                         min-width="150px"
                         prop="downloads_report_id"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.downloads_report_id}}</b>
          </template>
        </el-table-column>
  
        <el-table-column
          label="Net Income"
          prop="net_income"
          min-width="150px"
          sortable
        >
          <template v-slot="{row}">
            <div v-if="row.net_income != undefined">
              {{parseFloat(row.net_income).toLocaleString(undefined, {minimumFractionDigits: 2})}}            
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Commitment"
          prop="commitment"
          min-width="150px"
          sortable
        >
          <template v-slot="{row}">
            <div v-if="row.commitment != undefined">
              {{parseFloat(row.commitment).toLocaleString(undefined, {minimumFractionDigits: 2})}}            
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Variable Expenses"
          prop="variable_expenses"
          min-width="150px"
          sortable
        >
          <template v-slot="{row}">
            <div v-if="row.variable_expenses != undefined">
              {{parseFloat(row.variable_expenses).toLocaleString(undefined, {minimumFractionDigits: 2})}}            
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="Cash Flow"
          prop="cash_flow"
          min-width="150px"
          sortable
        >
          <template v-slot="{row}">
            <div v-if="row.cash_flow != undefined">
              <template v-if="row.cash_flow < 0">
                <span class="text-red">({{parseFloat(Math.abs(row.cash_flow)).toLocaleString(undefined, {minimumFractionDigits: 2})}})</span>
              </template>
              <template v-else>
                <span class="text-green">{{parseFloat(row.cash_flow).toLocaleString(undefined, {minimumFractionDigits: 2})}}</span>            
              </template>
            </div>
          </template>  
        </el-table-column>

        <el-table-column
          label="Net Worth"
          prop="net_worth"
          min-width="150px"
          sortable
        >
          <template v-slot="{row}">
            <div v-if="row.net_worth != undefined">
              <template v-if="row.net_worth < 0">
                <span class="text-red">({{parseFloat(Math.abs(row.net_worth)).toLocaleString(undefined, {minimumFractionDigits: 2})}})</span>
              </template>
              <template v-else>
                <span class="text-green">{{parseFloat(row.net_worth).toLocaleString(undefined, {minimumFractionDigits: 2})}}</span>            
              </template>
            </div>
          </template>  
        </el-table-column>

        <el-table-column label="Action" min-width="140px" align="center">
          <div slot-scope="{row}" class="table-actions btn-group-vertical report-action">
            <!-- <base-button type="primary" icon size="sm" @click.prevent="onEdit(row)">
              <span class="btn-inner--text">Edit</span>
            </base-button> -->
            <base-button v-if="row.financial_proposal_file.attach_file" type="primary" icon size="sm" @click.prevent="onViewPDF(row)">
              <span class="btn-inner--text">View</span>
            </base-button>
            <base-button v-if="row.financial_proposal_file.attach_file" type="primary" icon size="sm" @click.prevent="onDownload(row)">
              <span class="btn-inner--text">Download</span>
            </base-button>
          </div>
        </el-table-column>

        <el-table-column
          label="SSE / SSA"
          prop="agent_name"
          min-width="150px"
          sortable
        ></el-table-column>

        <el-table-column
          label="PDF Generated Date"
          prop="pdf_generated_date"
          min-width="150px"
          sortable
        ></el-table-column>
      </el-table>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
  
            <span v-if="selectedRows.length">
              &nbsp; &nbsp; {{selectedRows.length}} rows selected
            </span>
          </p>
  
        </div>
        <base-pagination
          class="pagination-no-border"
          :current="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
          @change="paginationChanged($event)"
        >
        </base-pagination>
      </div>
  
    </b-card>
  
  </template>
  <script>
    import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option } from 'element-ui'
    import axios from 'axios'
    import {apiDomain, getHeader} from '@/assets/js/config.js'
    
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    import { BasePagination } from '@/components';
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import debounce from 'lodash.debounce';
  
    export default {
      name: 'customer-financial-proposal-table',
      mixins: [clientPaginationMixin],
      components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
      },
      data() {
        return {
          propsToSearch:['agent_name'],
          tableData: [],
          currentPage: 1,
          mode: 'listing',
          selectedRows: [],
          searchText: '',
          debouncedHandler: '',
          TableColumn:[{
            type: 'selection'
          }]
        };
      },
      created(){
        this.pdfDownloadsReportLogList();
      },
      mounted(){
        this.debouncedHandler = debounce(() => {
          // this.searchFinancialProposalList();
        }, 500);
      },
      methods: {
        paginationChanged(page) {
          this.pagination.currentPage = page
        },
        selectionChange(selectedRows) {
          this.selectedRows = selectedRows
        },
        pdfDownloadsReportLogList(){
          axios.get(apiDomain + 'financial_proposal/get_download_report_log_by_customer_id/' + this.$route.params.customer_id, { headers: getHeader() })
          .then(response => {
            this.tableData = response.data.data
          })
          .catch ( error => {
              _gNotif.errorFunction(error,null, "Show Financial Proposal") 
          });
        },
        searchFinancialProposalList()
        {
          const postData = {
            controller_name : "FinancialProposalController",
            search_text : this.searchText,
            table_column: ["customer_name"]
          }
  
          axios.post(apiDomain + 'setup/data_search', postData  ,{ headers: getHeader() })
          .then ( response => {
            if(response.data.data.length === 0){
              return this.$notify({
                message:
                  '<b>Financial Proposal : </b> - No Results.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
              });
            }
            if (response.status === 200)
            {
              this.tableData = response.data.data
              this.$notify({
                message:
                  '<b>Financial Proposal : </b> - Search Successful.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
              });
  
            }
          })
          .catch ( error => {
               
              _gNotif.errorFunction(error,null, "Financial Proposal Listing")
          });
        },
        onViewPDF(row) {
          axios.get(apiDomain + 'financial_proposal/download_financial_proposal_report/' + row.financial_proposal_file.financial_proposal_file_id + '/view' ,{ headers: getHeader(), responseType: "blob" })
          .then ( response => {
            if (response.status === 200)
            {
                var FILE = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));        
                var docUrl = document.createElement('a');
                docUrl.href = FILE;
                docUrl.setAttribute('download', row.attach_file);
                document.body.appendChild(docUrl);
                window.open(docUrl);
            }
          })
          .catch ( error => {
              _gNotif.errorFunction(error,null, "Download Financial Proposal Report")
          });
        },
        onDownload(row) {
          axios.get(apiDomain + 'financial_proposal/download_financial_proposal_report/' + row.financial_proposal_file.financial_proposal_file_id + '/download' ,{ headers: getHeader(), responseType: "blob" })
          .then ( response => {
            if (response.status === 200)
            {
                var FILE = window.URL.createObjectURL(new Blob([response.data]));        
                var docUrl = document.createElement('a');

                docUrl.href = FILE;
                docUrl.setAttribute('download', row.attach_file);
                document.body.appendChild(docUrl);
                docUrl.click();
            }
          })
          .catch ( error => {
              _gNotif.errorFunction(error,null, "Download Financial Proposal Report")
          });
        }
  
      }
    }
  </script>
  <style scoped>
    .report-action {
      width: 80px
    }
  </style>